import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    DeleteLandingPage as DeleteLandingPageMutation,
    DeleteLandingPageVariables as DeleteLandingPageMutationVariables,
} from 'nutshell-graphql-types';

import DELETE_LANDING_PAGE from '../mutations/delete-landing-page.graphql';
import GET_LANDING_PAGES from '../queries/get-landing-pages.graphql';

export function useDeleteLandingPage(archived: boolean): {
    deleteLandingPage: (id: string) => Promise<any>;
    isDeleting: boolean;
    error: string | null | undefined;
} {
    const [deleteLandingPage, {loading: isDeleting, error}] = useMutation<
        DeleteLandingPageMutation,
        DeleteLandingPageMutationVariables
    >(DELETE_LANDING_PAGE);

    // @ts-expect-error
    const errorMessage = safelyGetGraphQLErrorMessage(error);

    return {
        deleteLandingPage: (id: string) =>
            deleteLandingPage({
                variables: {input: {id}},
                update: (proxy, mutationResults) => {
                    const deletedPage =
                        mutationResults &&
                        mutationResults.data &&
                        mutationResults.data.pageDelete &&
                        mutationResults.data.pageDelete.page;

                    const cacheResult = proxy.readQuery({
                        query: GET_LANDING_PAGES,
                        variables: {
                            archived,
                        },
                    });

                    if (cacheResult && deletedPage) {
                        proxy.writeQuery({
                            query: GET_LANDING_PAGES,
                            variables: {archived},
                            data: {
                                // @ts-expect-error
                                pages: cacheResult.pages.filter(
                                    // @ts-expect-error
                                    (page) => page.id !== deletedPage.id
                                ),
                            },
                        });
                    }
                },
            }),
        isDeleting,
        error: errorMessage,
    };
}
